/* ==========================================================================
   SKOCKZ scroll-reactive marquees — assets/skx-marquee.js
   The three ticker strips speed up as you scroll down and run backwards when
   you scroll up, instead of crawling at one fixed speed forever.

   The strips are AI-generated blocks whose class names carry a per-block hash
   (.ai-marquee-ticker__track-<hash>), so they are matched on the stable prefix
   rather than any one hash — a new strip added in the theme editor is picked
   up with no code change.

   This REPLACES their CSS animation rather than tweaking it. Retiming a
   running CSS animation makes it jump, because progress is elapsed/duration;
   driving the transform directly is the only way to change speed and
   direction smoothly.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var html = document.documentElement;
  var GAIN = parseFloat(html.getAttribute('data-skx-marquee')) || 0.010;
  var MAX_FACTOR = 14;          /* hard cap, as a multiple of the strip's own speed */

  var tracks = [];
  var visible = 0;
  var running = false;
  var lastY = null, lastT = 0, vel = 0;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var t = entries[i].target.__skx;
      if (!t || t.on === entries[i].isIntersecting) continue;
      t.on = entries[i].isIntersecting;
      visible += t.on ? 1 : -1;
    }
    if (visible > 0) start();
  }, { rootMargin: '120px' });

  /* Works whichever element is doing the scrolling: .page-wrapper owns the
     scroll at desktop widths but is overflow:visible on a phone, where the
     document scrolls instead. Only one of the two ever moves, so the sum is
     the real scroll position either way. */
  function scrollPos() {
    var pw = document.querySelector('.page-wrapper');
    return (document.scrollingElement ? document.scrollingElement.scrollTop : 0) +
           (pw ? pw.scrollTop : 0);
  }

  function measure(t) {
    var first = t.el.firstElementChild;
    /* Wrap on the width of ONE content block, in pixels — not on -50%. The
       strip's own script duplicates the content to fill the viewport, so the
       number of copies is not fixed and a percentage wrap would drift. */
    t.span = first ? first.offsetWidth : 0;
  }

  function respan(t) {
    measure(t);
    t.base = t.span ? t.span / t.dur : 0;
  }

  function collect() {
    var els = document.querySelectorAll('[class*="ai-marquee-ticker__track-"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__skx) continue;

      var dur = parseFloat(getComputedStyle(el).animationDuration) || 15;
      var t = { el: el, base: 0, dur: dur, pos: 0, span: 0, on: false };
      measure(t);
      /* Their keyframes travel 50% of the track in `dur`, so match that speed
         in px/s and the takeover is invisible until you scroll. */
      t.base = t.span ? t.span / dur : 0;

      el.style.animation = 'none';
      el.style.willChange = 'transform';
      el.__skx = t;
      tracks.push(t);
      io.observe(el);
    }
  }

  function frame(now) {
    if (!running) return;

    var dt = lastT ? Math.min((now - lastT) / 1000, 0.05) : 0.016;
    lastT = now;

    var y = scrollPos();
    if (lastY === null) lastY = y;
    var raw = (y - lastY) / Math.max(dt, 0.001);       /* px/s, + = scrolling down */
    lastY = y;

    vel += (raw - vel) * 0.25;                          /* smooth out jitter */
    if (vel < 2 && vel > -2) vel = 0;

    for (var i = 0; i < tracks.length; i++) {
      var t = tracks[i];
      if (!t.on || !t.span) continue;

      var speed = t.base + vel * GAIN * t.base;         /* scroll scales its own speed */
      var cap = t.base * MAX_FACTOR;
      if (speed > cap) speed = cap;
      if (speed < -cap) speed = -cap;

      t.pos -= speed * dt;
      t.pos %= t.span;
      if (t.pos > 0) t.pos -= t.span;
      t.el.style.transform = 'translate3d(' + t.pos.toFixed(2) + 'px,0,0)';
    }

    if (visible > 0) requestAnimationFrame(frame);
    else running = false;                               /* nothing on screen: stand down */
  }

  function start() {
    if (running) return;
    running = true;
    lastT = 0;
    lastY = null;
    requestAnimationFrame(frame);
  }

  collect();

  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var i = 0; i < tracks.length; i++) respan(tracks[i]);
    }, 200);
  });

  /* Strips can arrive late: the theme editor re-renders sections, and the
     marquee element duplicates its own content on connectedCallback. */
  document.addEventListener('shopify:section:load', function () { setTimeout(collect, 60); });
  window.addEventListener('load', function () {
    setTimeout(function () {
      collect();
      for (var i = 0; i < tracks.length; i++) if (!tracks[i].span) respan(tracks[i]);
    }, 100);
  });
})();
